import { AxiosError } from "axios"

import { queryClient } from "~/backend/queryClient"
import { useCreateContactByEmail } from "~/gen/api/hooks"
import { showAxiosError } from "~/utils/showAxiosError"

export const useCreateContactByEmailMutation = ({
  searchSupplier: _searchSupplier,
}: {
  searchSupplier: string
}) =>
  useCreateContactByEmail({
    mutation: {
      onSuccess: async (data) => {
        if (data) {
          queryClient.invalidateQueries({
            queryKey: [{ url: "/v1/client-settings/find-supplier-mapping" }],
            refetchType: "all",
          })
        }
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          showAxiosError({
            notificationTitle: "Supplier create error",
            notificationMessage:
              "Supplier create failed : " + error.response?.data?.message,
            showNotification: true,
            error,
          })
        }
      },
    },
  })
